module.exports = __webpack_public_path__ + "static/media/icon-documentacion.e42efd2b.svg";